<template>
  <div class="cdy">
    <div class="top-banner">
      <img src="./img/top-banner.jpg"/>
      <div class="input-wrap">
        <search type="cdy" placeholder="职位名／公司名／职位编号"></search>
      </div>
    </div>
    <filter-nav type="positions" :tag-list="tagList" :company-list="companyList" :loading="loading"></filter-nav>
    <div class="position-list-wrap">
      <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
        <van-list
                v-if="(list && list.length) || loading"
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                finished-text="没有更多了"
                @load="onLoad">
          <position v-for="(item,index) in list" :key="index" :position="item"></position>
        </van-list>
        <no-data v-else></no-data>
      </van-pull-refresh>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .top-banner{
    width: 100%;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }
    .input-wrap{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      .val-search{
        background: none;
      }
    }
  }
  .position-list-wrap{
    width: 100%;
    background-color: #f5f5f5;
    min-height: 400px;
  }
</style>
<style lang="scss">
.cdy{
  .input-wrap{
    .van-search__content{
      // background-color: #f0f0f0;
    }
  }
  .filter{
    .van-tree-select{
      height: 240px !important;
    }
    .van-dropdown-item__content{
      .other-dropdown{
        max-height: 240px !important;
      }
    }
  }
}
</style>
<script>
import Search from '@/components/picker/search'
import FilterNav from '@/components/picker/filterNav'
import Position from "@/components/position/position";
import {getPositionList, getPositionTags, getPositionStatistics} from '@/api/positions'
import NoData from "@/components/noData";
import {  cdyLogo } from "@/common/utils/share-img";
export default {
  name: "cdy-module",
  components: {
    Position,
    Search,
    FilterNav,
    NoData
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      tagList: [],
      companyList: [],
      isDownLoading: false//控制下拉刷新的加载动画
    };
  },
  methods: {
    //下拉刷新
    onDownRefresh() {
      this.pageNo = 1;
      this.finished = false;
      this.isDownLoading = true;
      this.onLoad(); //加载数据
    },
    onLoad() {
      let params = {pageNo:this.pageNo, pageSize: this.pageSize, ...this.$route.query,enterpriseTagIds: "316714007048855552"};

      if(params.companyId && (params.switchOn === 'false' || params.switchOn === false)){
        params.excludeCompanyId = params.companyId;
        params.excludeCompanyId = params.excludeCompanyId.replace(/\|/g, ',');
        delete params.companyId;
      }
      
      getPositionList(params).then(res=>{
        let curIds = [];
        if(res&&res.data && res.data.positionTags){
          res.data.positionTags.forEach(item=>{
            item.positionTagIdsForSearchUnderRange = item.code;
          })
          this.tagList = res.data.positionTags;
        }

        if(res&&res.data&&res.data.companys&&res.data.companys.values&&res.data.companys.values.length){
          this.companyList = res.data.companys.values;
        }
        
        if(res&&res.data&&res.data.list){
          curIds = res.data.list.map(item=>item.positionId) || [];

          res.data.list.forEach(item=>{
            item.positionTags = [];
            item.statics = {};
          });

          if(this.pageNo ==1){
            this.list = res.data.list;
          }else{
            this.list = this.list.concat(res.data.list);
          }

          if(res.data.list.length < this.pageSize){
            //最后一页不足10条
            this.finished = true;
          }else{
            this.pageNo++;
          }
        }else{
          //加载结束
          this.finished = true;
        }

        if(curIds && curIds.length){
          this.positionTags(curIds);
          this.positionStatistics(curIds);
        }
      }).catch( err => {
        console.log(err,'err');
      }).finally(() => {
        this.isDownLoading = false;
        this.loading = false;
      });
    },
    positionTags(curIds){
      getPositionTags({positionIds: curIds.join(',')}).then(res=>{
        if(res&&res.data){
          this.list.forEach(item=>{
            if(res.data[item.positionId]){
              item.positionTags = res.data[item.positionId];  
            }
          });
        }
      }).catch(err=>{})
    },
    positionStatistics(curIds){
      getPositionStatistics({positionIds: curIds.join(',')}).then(res=>{
        if(res&&res.data){
          this.list.forEach(item=>{
            if(res.data[item.positionId]){
              item.statics = res.data[item.positionId];  
            }
          });
        }
      }).catch(err=>{})
    }
  },
  watch: {
    $route(n,o){
      this.list = [];
      this.pageNo = 1;
      this.finished = false;
      this.loading = true;
      this.onLoad();
    }
  },
  created() {
    this.loading = true;
    this.onLoad();
  
    this.$store.commit('comp/WX_SHARE',{
      title:'成单易 - 为您甄选反馈快、流程短、成单易的优质雇主',
      imgUrl:cdyLogo
    });
  }
};
</script>
